/**
 * Routes a visitor may be on without a session.
 *
 * SessionProvider wraps the whole router, so /api/me is fetched on every
 * route including the public ones. Without this list a 401 there bounces the
 * browser to Entra — which is what sent someone clicking "Try the demo"
 * straight to a Microsoft sign-in prompt.
 *
 * A list rather than a check at each call site, because the failure is silent:
 * adding a public route and forgetting the exemption produces a redirect to
 * Entra, not an error, and it looks like a routing bug rather than this.
 */
export const PUBLIC_PATHS = [
  '/',          // the landing page
  '/demo',      // self-service demo: email, code, in
  '/error'      // sign-in failures, which must not retry into the same failure
];

export function isPublicPath(pathname) {
  if (typeof pathname !== 'string' || pathname === '') return false;
  // Trailing slashes only; no prefix matching, so /demo does not exempt
  // /demo-something that might genuinely need a session.
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return PUBLIC_PATHS.includes(path);
}
